import React from 'react';
import { MailFill, WhatsappFill } from '../../../../assets/img/svg/icons';

const Informativo: React.FC<{}> = () => {
    return (
        <section className='pt-7 pb-4'>
            <div className="max-w-screen-md mx-auto px-4">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-y-4">
                    <div className="md:border-r border-black/10 w-full flex justify-center md:justify-start">
                        <a href="https://api.whatsapp.com/send?phone=5511971823024" target='_blank' className="inline-flex items-center gap-x-4 gap-y-2 text-sm transition-all duration-200 hover:text-main-pink flex-col md:flex-row text-center md:text-left">
                            <div className="bg-main-pink rounded-full flex items-center justify-center w-14 h-14 drop-shadow-lg transition-all duration-200 hover:text-main-pink">
                                <WhatsappFill className='w-1/2 h-1/2 object-contain' />
                            </div>

                            <div className="flex flex-col font-semibold">
                                <div className="text-xs">Whatsapp</div>
                                <div className="text-xl">
                                    <span className='font-light'>(11)</span> 97182-3024
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="md:border-r border-black/10 flex items-center justify-center w-full -order-1 md:order-none col-span-2 md:col-span-1">
                        <a href="mailto:info@teenager.com.br" target='_blank' className="inline-flex items-center gap-x-4 gap-y-2 text-sm transition-all duration-200 hover:text-main-pink flex-col md:flex-row text-center md:text-left">
                            <div className="bg-main-pink rounded-full flex items-center justify-center w-14 h-14 drop-shadow-lg">
                                <MailFill className='w-1/2 h-1/2 object-contain' />
                            </div>

                            info@teenager.com.br
                        </a>
                    </div>

                    <div className="flex items-center justify-center md:justify-end w-full">
                        <div className="flex items-center gap-4 text-sm">
                            <a href="https://api.whatsapp.com/send?phone=5511948586664" target='_blank' className="inline-flex items-center gap-x-4 gap-y-2 text-sm transition-all duration-200 hover:text-main-pink flex-col md:flex-row text-center md:text-left">
                                <div className="bg-main-pink rounded-full flex items-center justify-center w-14 h-14 drop-shadow-lg">
                                    <WhatsappFill className='w-1/2 h-1/2 object-contain' />
                                </div>

                                <div className="flex flex-col font-semibold">
                                    <div className="text-xs">Assessoria de Imprensa</div>
                                    <div className="text-xl">
                                        <span className='font-light'>(11)</span> 94858-6664
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Informativo;